import { computePosition, flip, shift, offset } from '@floating-ui/dom';

//
// <span use:tooltip data-tooltip={`My tooltip with more content.
//                          My tooltip with more content`}>Hover me</span>
//
export function tooltip(node, tooltipText) {
    let tooltip;
    let tooltipTimeout; // scoped per instance

    function update() {
        if (!tooltip) return;

        computePosition(node, tooltip, {
            // Add your options here if needed
            placement: 'top',
            //middleware: [flip(), shift({padding: 5})],
            middleware: [offset(10), flip(), shift({padding: 5})],
        }).then(({ x, y }) => {
            Object.assign(tooltip.style, {
                left: `${x}px`,
                top: `${y}px`,
            });
        });
    }

    function showTooltip() {
        if (tooltipTimeout) return;

        tooltipTimeout = setTimeout(() => {
            tooltipTimeout = null; // clear after trigger

            if (!tooltip) {
                tooltip = document.createElement('div');
                tooltip.classList.add('floating-tooltip');
                tooltip.style.opacity = 0;
                document.body.appendChild(tooltip);
            }

            tooltip.textContent = tooltipText || node.dataset.tooltip;
            tooltip.style.display = 'block';
            update();
            requestAnimationFrame(() => {
                tooltip.style.opacity = '0.9';
            });
        }, 200); // Delay before showing
    }

    function hideTooltip() {
        if (tooltipTimeout) {
            clearTimeout(tooltipTimeout);
            tooltipTimeout = null;
        }

        if (tooltip) {
            requestAnimationFrame(() => {
                tooltip.style.opacity = 0;
                tooltip.style.display = 'none';
            });
        }
    }

    const events = [
        ['mouseenter', showTooltip],
        ['mouseleave', hideTooltip],
        ['focus', showTooltip],
        ['blur', hideTooltip],
        ['click', hideTooltip]
    ];

    events.forEach(([event, handler]) => node.addEventListener(event, handler));

    return {
        destroy() {
            events.forEach(([event, handler]) => node.removeEventListener(event, handler));
            if (tooltipTimeout) clearTimeout(tooltipTimeout);
            if (tooltip) {
                tooltip.remove();
                tooltip = null;
            }
        },
    };
}


export function applyTooltips(el) {
    const container = el || document;
  
    container.querySelectorAll('.has-floating-tooltip').forEach(node => {
        node.classList.remove('has-floating-tooltip'); // Remove the class to mark it as applied
        tooltip(node); // Apply the tooltip
    });
}


export function createVirtualElement(x, y) {
    return {
        getBoundingClientRect() {
            /*return {
                top: y,
                left: x,
                bottom: y,
                right: x,
                width: 0,
                height: 0,
            };*/
            console.log(x, y);
            return {
                x: x,
                left: x,
                y: y,
                top: y,
                width: 1,
                height: 1,
                right: x+1,
                bottom: y+1,
            };
        },
    };
}
  